/*
 * ez-faq — FAQ accordion (design_system.md §6 3.5).
 *
 * Progressive disclosure via max-height + opacity (never a height:auto transition),
 * plus<->minus icon rotate (CSS, keyed on aria-expanded), SINGLE-OPEN by default
 * (design_system.md §6 3.5 [v1.3]: opening one closes the open one; the open item carries
 * .is-open for the §3.7 surface-lift + accent icon). One vanilla custom element, defined
 * once, no framework. Panels render open in HTML and the not-open-by-default ones carry
 * data-collapsed; JS owns the toggle from there. Reduced motion collapses/expands instantly.
 * Click is delegated so it survives editor re-render.
 */
(function () {
  if (customElements.get('ez-faq')) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class EzFaq extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);
      // reflect the initial open state into .is-open (surface-lift + accent) for open-by-default items
      this.querySelectorAll('.ez-faq__q[aria-expanded="true"]').forEach(function (btn) {
        var item = btn.closest('.ez-faq__item');
        if (item) item.classList.add('is-open');
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    _onClick(e) {
      var btn = e.target.closest('.ez-faq__q');
      if (!btn || !this.contains(btn)) return;
      var panel = btn.parentElement.querySelector('.ez-faq__panel');
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      if (open) {
        this._close(btn, panel);
      } else {
        this._closeOthers(btn); // [v1.3] single-open: opening one closes the open one
        this._open(btn, panel);
      }
    }

    // [v1.3] single-open — close any other currently-open item in this accordion.
    _closeOthers(current) {
      var self = this;
      this.querySelectorAll('.ez-faq__q[aria-expanded="true"]').forEach(function (btn) {
        if (btn === current) return;
        var panel = btn.parentElement.querySelector('.ez-faq__panel');
        if (panel) self._close(btn, panel);
      });
    }

    _open(btn, panel) {
      btn.setAttribute('aria-expanded', 'true');
      var item = btn.closest('.ez-faq__item');
      if (item) item.classList.add('is-open');
      if (reduceMotion.matches) {
        panel.removeAttribute('data-collapsed');
        panel.style.maxHeight = '';
        return;
      }
      panel.style.maxHeight = '0px';
      panel.removeAttribute('data-collapsed');
      panel.getBoundingClientRect();
      panel.style.maxHeight = panel.scrollHeight + 'px';
      var done = function (ev) {
        if (ev.propertyName !== 'max-height') return;
        panel.style.maxHeight = '';
        panel.removeEventListener('transitionend', done);
      };
      panel.addEventListener('transitionend', done);
    }

    _close(btn, panel) {
      btn.setAttribute('aria-expanded', 'false');
      var item = btn.closest('.ez-faq__item');
      if (item) item.classList.remove('is-open');
      if (reduceMotion.matches) {
        panel.setAttribute('data-collapsed', '');
        panel.style.maxHeight = '';
        return;
      }
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.getBoundingClientRect();
      panel.setAttribute('data-collapsed', '');
      panel.style.maxHeight = '0px';
      var done = function (ev) {
        if (ev.propertyName !== 'max-height') return;
        panel.style.maxHeight = '';
        panel.removeEventListener('transitionend', done);
      };
      panel.addEventListener('transitionend', done);
    }
  }

  customElements.define('ez-faq', EzFaq);
})();
